export const saharaEndpoints = {
    auth: {
        login: {
            api: '/api/auth/login',
            method: 'POST',
            parameter: false
        },
        google: {
            api: '/api/auth/google',
            method: 'POST',
            parameter: false
        },
        requestResetPassword: {
            api: '/api/auth/resetpassword/request',
            method: 'POST',
            parameter: false
        },
        requestSetNewPassword: {
            api: '/api/auth/setnewpassword/request',
            method: 'POST',
            parameter: false
        },
        resetPassword: {
            api: '/api/auth/resetpassword',
            method: 'POST',
            parameter: false
        },
        setNewPassword: {
            api: '/api/auth/setnewpassword',
            method: 'POST',
            parameter: false
        },
        refreshToken: {
            api: '/api/auth/refreshtoken',
            method: 'GET',
            parameter: false
        }
    },
    translation: {
        list: {
            api: '/api/translation',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/api/translation/details',
            method: 'GET',
            parameter: true
        },
        add: {
            api: '/api/translation/add',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/api/translation/edit',
            method: 'POST',
            parameter: false
        },
        delete: {
            api: '/api/translation/delete',
            method: 'POST',
            parameter: false
        }
    },
    notification: {
        list: {
            api: '/api/notifications/list/user',
            method: 'GET',
            parameter: false
        },
        listArchived: {
            api: '/api/notifications/list/user/archived',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/api/mercury/notifications/details',
            method: 'GET',
            parameter: false
        },
        markAsRead: {
            api: '/api/mercury/notifications/status',
            method: 'POST',
            parameter: false
        },
        labelChange: {
            api: '/api/mercury/notifications/labelChange',
            method: 'POST',
            parameter: false
        }
    },
    conversation: {
        list: {
            api: '/api/conversation/list/domain',
            method: 'GET',
            parameter: false
        },
        listArchived: {
            api: '/api/conversation/list/domain/archived',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/api/mercury/conversation/details',
            method: 'GET',
            parameter: true
        },
        markAsRead: {
            api: '/api/mercury/conversation/markAsRead',
            method: 'POST',
            parameter: false
        },
        create: {
            api: '/api/mercury/conversation/create',
            method: 'POST',
            parameter: false
        },
        archive: {
            api: '/api/mercury/conversation/archive',
            method: 'POST',
            parameter: false
        },
        countAllNew: {
            api: '/api/mercury/conversation/countNewMessagesPerUser',
            method: 'GET',
            parameter: false
        }
    },
    configuration: {
        languages: {
            api: '/api/sahara/configuration/dictionary/language',
            method: 'GET',
            parameter: false
        },
        application: {
            api: '/api/sahara/configuration/dictionary/application',
            method: 'GET',
            parameter: false
        },
        domainsEnabledProductMkpLink: {
            api: '/api/sahara/configuration/domains-enabled-mkp',
            method: 'GET',
            parameter: false
        }
    },
    campaignManager: {
        list: {
            api: '/api/sahara/marketing-campaign',
            method: 'GET',
            parameter: true
        },
        details: {
            api: '/api/sahara/marketing-campaign/details',
            method: 'GET',
            parameter: true
        },
        add: {
            api: '/api/sahara/marketing-campaign/add',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/api/sahara/marketing-campaign/edit',
            method: 'POST',
            parameter: false
        }
    },
    message: {
        create: {
            api: '/api/mercury/conversation/message/create',
            method: 'POST',
            parameter: false
        },
        delete: {
            api: '/api/mercury/conversation/message/delete',
            method: 'POST',
            parameter: false
        }
    },
    alert: {
        show: {
            api: '/api/alert/show',
            method: 'GET',
            parameter: false
        },
        list: {
            api: '/api/sahara/alert',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/api/sahara/alert/details',
            method: 'GET',
            parameter: true
        },
        add: {
            api: '/api/sahara/alert/add',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/api/sahara/alert/edit',
            method: 'POST',
            parameter: false
        },
        delete: {
            api: '/api/sahara/alert/delete',
            method: 'POST',
            parameter: false
        }
    },
    reviews: {
        list: {
            api: '/api/iris/reviews/list/moderator',
            method: 'GET',
            parameter: false
        }
    },
    report: {
        template: {
            list: {
                api: '/api/report/template',
                method: 'GET',
                parameter: false
            },
            details: {
                api: '/api/report/template/details',
                method: 'GET',
                parameter: true
            },
            add: {
                api: '/api/report/template/add',
                method: 'POST',
                parameter: false
            },
            edit: {
                api: '/api/report/template/edit',
                method: 'POST',
                parameter: false
            },
            delete: {
                api: '/api/report/template/delete',
                method: 'POST',
                parameter: true
            },
            generate: {
                api: '/api/report/generate',
                method: 'POST',
                parameter: true
            },
            dictionary: {
                api: '/api/sahara/report/template/dictionary',
                method: 'GET',
                parameter: true
            }
        },
        list: {
            api: '/api/report',
            method: 'GET',
            parameter: true
        },
        details: {
            api: '/api/report/details',
            method: 'GET',
            parameter: true
        }
    },
    upload: {
        storeFileDetails: '/api/file/store-details',
        signature: '/api/file/signature',
        complete: '/api/file/complete'
    },
    dictionary: {
        statesByCountry: {
            api: '/api/location/state/dictionary',
            method: 'GET',
            parameter: true
        },
        timezones: {
            api: '/api/location/timezone/dictionary',
            method: 'GET',
            parameter: false
        },
        countries: {
            api: '/api/location/country/dictionary',
            method: 'GET',
            parameter: false
        },
        languages: {
            api: '/api/location/language/dictionary',
            method: 'GET',
            parameter: false
        },
        translationType: {
            api: '/api/configuration/dictionary/types',
            method: 'GET',
            parameter: false
        }
    },
    location: {
        validateVAT: {
            api: '/api/location/vat/validate',
            method: 'GET',
            parameter: true
        }
    },
    other: {
        version: {
            api: '/api/version',
            method: 'GET',
            parameter: false
        }
    },
    accountFeatures: {
        details: {
            api: '/api/account-features/details',
            method: 'GET',
            parameter: true
        },
        add: {
            api: '/api/account-features/add',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/api/account-features/edit',
            method: 'POST',
            parameter: false
        }
    }
};



// WEBPACK FOOTER //
// ./src/endpoints/sahara.endpoints.ts